import { UseFormReturnType } from '@mantine/form';

// Utility type to generate all valid nested paths for a type
// Supports up to 3 levels deep, can be expanded if needed.

type Prev = [never, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
type Join<K, P> = K extends string | number
  ? P extends string | number
    ? `${K}.${P}`
    : never
  : never;
export type Paths<T, D extends number = 3> = [D] extends [never]
  ? never
  : T extends object
    ? {
        [K in keyof T & (string | number)]:
          | `${K}`
          | (Paths<T[K], Prev[D]> extends infer R
              ? R extends string | number
                ? Join<K, R>
                : never
              : never);
      }[keyof T & (string | number)]
    : '';

/**
 * Type-safe helper for Mantine form's getInputProps.
 *
 * @note This code is Claude-generated and I don't really understand it.
 * Seems to work though 🤞.
 */
export function getInputPropsSafe<T>(
  form: UseFormReturnType<T>,
  path: Paths<T>,
) {
  return form.getInputProps(path as string);
}
